import { Form } from "@redriver/cinnamon-mui";
import { resourceBackupTypesLookup } from "modules/lookups";

const ResourceBackupTypeRadioGroup = (props) => (
  <Form.RadioGroup {...props} lookup={resourceBackupTypesLookup} />
);

export default ResourceBackupTypeRadioGroup;
